class AjaxPagination {
  constructor() {
    this.postList = document.querySelector('.wp-block-post-template');
    this.loadPageLinks();
    this.events();
    this.pageNumber = 1;
  }

  loadPageLinks() {
    this.nextPageLink = document.querySelector('.wp-block-query-pagination-next');
    this.prevPageLink = document.querySelector('.wp-block-query-pagination-previous');
  }

  events() {
    if (this.nextPageLink) {
      this.nextPageLink.addEventListener('click', (e) => this.loadPosts(e, 'next'));
    }
    
    if (this.prevPageLink) { 
      this.prevPageLink.addEventListener('click', (e) => this.loadPosts(e, 'prev'));
    }
  }

  loadPosts(e, direction) {
    e.preventDefault();

    const linkElement = e.target.closest('[href]');
    if (!linkElement) {
      console.log("Cannot find a element with href");
      return;
    }

    const link = linkElement.href;

    fetch(link)
      .then(response => response.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        this.postList.innerHTML = doc.querySelector('.wp-block-post-template').innerHTML;

        this.loadPageLinks();
        this.events();

        if (direction === 'next') {
          this.pageNumber++;
          if (!this.prevPageLink) {
            this.prevPageLink = document.createElement('a');
            this.prevPageLink.className = 'wp-block-query-pagination-previous';
            this.prevPageLink.innerHTML = '←';
            this.nextPageLink.parentNode.insertBefore(this.prevPageLink, this.nextPageLink);
            this.prevPageLink.addEventListener('click', (e) => this.loadPosts(e, 'prev'));

            this.prevPageLink.addEventListener('mouseover', () => {
              this.prevPageLink.style.textDecoration = 'none';
            });
            this.prevPageLink.addEventListener('mouseout', () => {
              this.prevPageLink.style.textDecoration = 'none';
            });
          }
          // Update the 'href' attribute of the previous page link
          this.prevPageLink.href = window.location.href;
        } else if (direction === 'prev') {
          this.pageNumber--;
          if (!doc.querySelector('.wp-block-query-pagination-previous')) {
            this.prevPageLink.parentNode.removeChild(this.prevPageLink);
            this.prevPageLink = null;
          }
        }

        if (this.pageNumber === 1) {
          this.prevPageLink.style.pointerEvents = 'none';
          this.prevPageLink.style.opacity = '0.5';
        } else {
          this.prevPageLink.style.pointerEvents = 'auto';
          this.prevPageLink.style.opacity = '1';
        }
      })
      .catch(error => console.log(error));
  }
}

export default AjaxPagination;

